import { formFieldErrorHtml, mergePreviewStyle, toRGBA, getFontFamily } from "../parser/utils";
import { getFormLableStyleStr } from "../FormText/FormBaseStyle";

export default ({ data, id, root }) => {
  const {
    label,
    options,
    required,
    paddingTop,
    hideLabel,
    paddingBottom,
    paddingRight,
    paddingLeft,
    optionsDefaultFont,
    optionsFontSize,
    optionsFontColor,
    optionsHorizonAlignment,
    labelDefaultFont,
    labelFontSize,
    labelFontColor,
    labelHorizonAlignment,
  } = data;

  const {
    formBorderWidth,
    formBorderStyle,
    formBorderColor,
    formBorderRadius,
    formTextColor,
  } = root.data;

// 1. Get base styles string
  const baseLabelStyleStr = getFormLableStyleStr(data, root.data) || "";

  
  const overrideStyleParts = [];
  overrideStyleParts.push('display: flex');
  overrideStyleParts.push('align-items: flex-start');

  const finalLabelFontColor = labelFontColor || formTextColor;
  if (finalLabelFontColor) {
    overrideStyleParts.push(`color: ${toRGBA(finalLabelFontColor)}`);
  }
  if (labelDefaultFont) {
    overrideStyleParts.push(`font-family: ${labelDefaultFont}`);
  }
  const trimmedLabelFontSize = String(labelFontSize || "").trim();
  if (trimmedLabelFontSize && trimmedLabelFontSize !== '0') {
    overrideStyleParts.push(`font-size: ${trimmedLabelFontSize}px`);
  }
  overrideStyleParts.push(`justify-content: ${labelHorizonAlignment || "start"}`);

  // This string is what you consider your 'labelInlineStyle'
  const labelInlineStyleString = overrideStyleParts.join('; ');

  // 3. Use the merge function with the desired parameter name
  const finalLabelStyleStr = mergePreviewStyle(baseLabelStyleStr, labelInlineStyleString);

  const fallbackFont = getFontFamily(optionsDefaultFont, root?.data?.defultFont);

  return `
    <div
      class="rip-field-group"
      style="
        text-align: left;
        padding-top: ${paddingTop}px;
        padding-bottom: ${paddingBottom}px;
        padding-right: ${paddingRight}px;
        padding-left: ${paddingLeft}px;
        border-color: ${toRGBA(formBorderColor)};
      "
    >
      <label
            for="${id}"
            class="rip-field-label"
                  style="${finalLabelStyleStr}; display: ${
        hideLabel ? "none" : "flex"
      };"
    "
          >
            ${
              required
                ? '<span style="color: #ff4d4f; margin-right: 4px;">*</span>'
                : ""
            }${label}
        </label>

      <div
        style="
          border-width: ${formBorderWidth}px;
          border-style: ${formBorderStyle};
          border-color: ${toRGBA(formBorderColor)};
          border-radius: ${formBorderRadius}px;
          display: flex;
          flex-direction: column;
        "
      >
        ${options
          .map((item, index) => {
            const isLast = options.length === index + 1;
            const borderBottom = isLast
              ? 0
              : [
                  formBorderWidth + "px",
                  formBorderStyle,
                  toRGBA(formBorderColor),
                ].join(" ");

            return `
          <div
            style="
              height: 35px;
              padding: 0 8px;
              border-bottom: ${borderBottom};
              display: flex;
              justify-content: ${optionsHorizonAlignment};
              align-items: center;
              gap: 8px;
            "
          >
            <input
              type="checkbox"
              name="${id}"
              id="${id}-${index}"
              value="${item.label}"
              style="
                width: 16px;
                height: 16px;
                border-radius: 2px;
                border: 1px solid #cccccc;
                margin: 0;
                flex-shrink: 0;
              "
            />
            <label
              for="${id}-${index}"
              style="
                margin: 0;
                color: ${toRGBA(optionsFontColor || formTextColor)};
                font-family: ${fallbackFont};
                font-size: ${optionsFontSize}px;
                display: flex;
                align-items: center;
              "
            >
              ${item.label}
            </label>
          </div>`;
          })
          .join('')}
      </div>

      ${formFieldErrorHtml({ id })}
    </div>
  `;
};
